import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { ALogo, AButton } from '../../atoms';
import { routes } from '../../../constants';

export default function OCmsHeader({
	title,
	description,
	buttonName,
	onClick,
}) {
	let button;

	if (onClick) {
		if (typeof onClick === 'function') {
			button = (
				<AButton
					value={buttonName}
					onClick={onClick}
				/>
			);
		} else {
			button = (
				<Link href={onClick} to={onClick} className="a-button a-button--default">
					{buttonName}
				</Link>
			);
		}
	}

	return (
		<header className="o-header-cms">

			<figure className="logo">
				<Link href={routes.CMS.DEFAULT} to={routes.CMS.DEFAULT}>
					<ALogo />
				</Link>
			</figure>
			<section>
				<article>
					<h1>{title}</h1>
					<p>{description}</p>
				</article>
				{button}
			</section>
		</header>
	);
}

OCmsHeader.propTypes = {
	title: PropTypes.string.isRequired,
	onClick: PropTypes.any,
	description: PropTypes.string,
	buttonName: PropTypes.string,
};

OCmsHeader.defaultProps = {
	onClick: undefined,
	description: '',
	buttonName: '',
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.cms-header.js